import { useState, useEffect } from 'react'

const CACHE_KEY = 'planPermissionsCache'
export const PLAN_PERMS_EVENT = 'planPermissionsUpdated'

const parseScript = (scriptStr) => {
  if (!scriptStr || !scriptStr.trim()) return {}
  try { return JSON.parse(scriptStr) } catch {
    try {
      const sanitized = scriptStr.replace(
        /([{,]\s*)([\p{L}_][\p{L}\p{N}_]*)\s*:/gu,
        '$1"$2":'
      )
      return JSON.parse(sanitized)
    } catch { return {} }
  }
}

const KEYS = [
  'muralInterativo', 'interatividade', 'vitrine', 'previsao', 'mapas', 'transito',
  'conteudos', 'podcast', 'robocast', 'listas', 'whatsapp',
  'participacoes', 'relatorios', 'bi', 'marketing', 'berta', 'tv30',
]

const DEFAULTS = {
  muralInterativo: true, interatividade: true, vitrine: true,
  previsao: true, mapas: true, transito: true, conteudos: true,
  podcast: true, robocast: true, listas: true,
  whatsapp: true, participacoes: true, relatorios: true, bi: true,
  marketing: false,
  berta: true, // Berta (redação): liberada para todas — ver src/configs/planPermissions.js
  tv30: true, // TV 3.0: idem
}

const readFromStorage = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user')) || {}
    const cached = localStorage.getItem(CACHE_KEY)
    const src = cached
      ? JSON.parse(cached)
      : parseScript(user.plan_script || '')
    const overrides = user.feature_overrides || {}

    const perms = {}
    for (const key of KEYS) {
      if (key in overrides) {
        perms[key] = overrides[key]
      } else if (key in src) {
        perms[key] = src[key] !== false
      } else {
        perms[key] = DEFAULTS[key] !== false
      }
    }

    localStorage.setItem(CACHE_KEY, JSON.stringify(perms))
    return perms
  } catch {
    return { ...DEFAULTS }
  }
}

export const usePlanPermissions = () => {
  const [permissions, setPermissions] = useState(readFromStorage)

  useEffect(() => {
    const refresh = () => setPermissions(readFromStorage())
    window.addEventListener(PLAN_PERMS_EVENT, refresh)
    return () => window.removeEventListener(PLAN_PERMS_EVENT, refresh)
  }, [])

  return permissions
}
